export enum PlanStep {
  evaluators = 1,
  objective = 2,
  strategy = 3,
  appraisal = 4,
  importSources = 5,
}

export enum ReviewStep {
  plan = 1,
  execute = 2,
  export = 3,
}
